import { render, staticRenderFns } from "./OnlineStructure.vue?vue&type=template&id=131b04ed&"
import script from "./OnlineStructure.vue?vue&type=script&lang=js&"
export * from "./OnlineStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OnlineStructure.vue"
export default component.exports